import { motion } from 'framer-motion';
import bgImg from '../assets/IMG_0500.jpg'; // Night wedding ceremony
import styles from './DestinationBridal.module.css';

const WA_DEST = 'https://wa.me/918890469900?text=Hi%2C%20I%27m%20interested%20in%20destination%20bridal%20services%20from%20Shobha%20Salon';

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 28 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.3 },
  transition: { duration: 0.85, delay, ease: [0.16, 1, 0.3, 1] },
});

export default function DestinationBridal() {
  return (
    <section id="destination" className={styles.section}>
      <motion.div
        className={styles.bg}
        style={{ backgroundImage: `url(${bgImg})` }}
        initial={{ scale: 1.06 }}
        whileInView={{ scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.6, ease: 'easeOut' }}
      />
      <div className={styles.overlay} />
      <div className={styles.grain} aria-hidden="true" />

      <div className={styles.content}>
        <motion.p className={styles.ornament} {...fadeUp(0.1)}>
          ✦ &nbsp; We Come To You &nbsp; ✦
        </motion.p>
        <motion.div className={styles.label} {...fadeUp(0.2)}>
          Destination Bridal
        </motion.div>
        <motion.h2 className={styles.heading} {...fadeUp(0.3)}>
          Your Palace,<br />Our Studio
        </motion.h2>
        <motion.p className={styles.desc} {...fadeUp(0.4)}>
          Shobha Salon travels to weddings across Rajasthan and beyond.
          From heritage palaces to luxury resort hotels, our team arrives
          fully equipped to deliver the same flawless results wherever
          your celebration takes place.
        </motion.p>
        <motion.p className={styles.venues} {...fadeUp(0.5)}>
          Available on special request. We travel to your venue, anywhere in India.
        </motion.p>
        <motion.a
          href={WA_DEST}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.cta}
          {...fadeUp(0.6)}
        >
          Plan Your Destination Bridal →
        </motion.a>
      </div>
    </section>
  );
}
